import React from "react";
import styled from "styled-components";

const MainContent = () => {
  return (
    <Content>
      {/* <img src="../react_logo.png" alt="Logo" />  */}

      <div className="main-content">MainContent</div>
      <h1>Heading</h1>
      <div className="input-container">
        <input
          className="input"
          placeholder="Seconds nmae"
          type={"text"}
        ></input>
        <input className="input" placeholder="First nmae" type={"text"}></input>
      </div>
      <button >Submit</button>
      <p>
        Various educators teach rules governing the length of paragraphs. They
        may say that a paragraph should be 100 to 200 words long, or be no more
        than five or six sentences. But a good paragraph should not be measured
        in characters, words, or sentences. The true measure of your paragraphs
        should be ideas.
      </p>
      <img src="../react_logo.png" />
    </Content>
  );
};

const Content = styled.section`
  /* display: flex; */
  background-color: cyan;
  border: 1px solid black;
  width: 70%;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  text-align: center;
  /* height: 100px; */
  p{
    text-align: left;
  }
  button{
    justify-content: center;
    margin: 1rem 0rem;
    text-align: center;
  }
  .main-content {
    /* background-color: red; */
    justify-content: center;
    align-items: center;
    font-size: 2rem;
  }
  .input-container {
    display: flex;
    gap: 1rem;
    /* margin: 1rem; */
  }
  .input {
    width: 50%;
  }
`;

export default MainContent;
